export interface Defer<T> {
  resolve: (value: T) => void;
  reject: (error: any) => void;
  promise: Promise<T>;
}

export const defer = <T>() => {
  const def: Defer<T> = {} as any;
  def.promise = new Promise<T>((resolve, reject) => {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
};
